const getShiftDurationInMs = (start: Date, end: Date, breakTimeInMinutes = 0) => {
  return end.getTime() - start.getTime() - breakTimeInMinutes * 60000;
};

export { getShiftDurationInMs };
